import axios, { AxiosResponse } from "axios";

import { UPDATESURL, DOMIAN } from "../../shared/constants";
import { IAdminLogin } from "../../shared/dtos";
import { getCookie, removeAllCookies } from "./cookies";

const axiosInterceptor = axios.create({
  baseURL: UPDATESURL,
});

axiosInterceptor.interceptors.request.use(
  async (req) => {
    const token = getCookie("access_token");
    const userid = getCookie("userId");
    const deviceId = getCookie("deviceId");
    const source = getCookie("source") ? getCookie("source") : "WEB";

    req.headers.Authorization = `userId=${userid};deviceId=${deviceId};source=${source};finupdate_token=${token}`;
    return req;
  },
  (error) => Promise.reject(error)
);

axiosInterceptor.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response ? err.response.status : null;
    if (status === 401) {
      handleLogout();
    }
    return Promise.reject(err);
  }
);
const handleLogout = () => {
  removeAllCookies();
  setTimeout(() => {
    window.location.href = "/";
  }, 100);
};

export const GetProfileDetailsNomineeAPICall = () => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/api/V1/common/profile_details`, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const GetNomineeDetailsAPICall = () => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/v1/api/nominee/get_nominee_details`, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const GetNomineeModificationRequestAPICall = () => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/v1/api/common/nominee/get_modifications_requests`, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const NomineeStageDetailsAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/v1/api/nominee/stage_details`, requestBody, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const UpdateNomineeDetailsAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/v1/api/nominee/update_nominee_details`, requestBody, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const CreateEsignConsentNomineeAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/v1/api/nominee/esign/create_consent/`, requestBody, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const CreateEsignPDFNomineeAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/v1/api/nominee/esign/create_pdf_esign`, requestBody, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const SaveEsignDocNomineeAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/v1/api/nominee/esign/save_signed_document`, requestBody, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const GetrelationDropDownAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/v1/api/common/nominee_details`, { params: requestBody })
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

export const NomineeDocumentUploadAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/api/V1/nominee/upload_document`, requestBody, {})
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const DeleteNomineeDocumentAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/api/V1/nominee/delete_document`, requestBody, {})
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
